/**
 * Handles the JavaScript associated with the Global navigation
 */
import scrollEvent from '../../components/fsUtils/scrollEvent';
import Viewports from '../../components/fsUtils/Viewports';
import screenLock from '../../components/fsUtils/screenLock';

class NavGlobal {

    /**
     * Intialize some variables for the Mobile Menu button and scroll positioning.
     * Bind a scroll event listener to the window object and tie it to 'watch' function.
     * Bind a click event listener to the mobile menu element and tie it to 'menuToggler' function.
     *
     * @since 0.1.0
     */
    constructor() {
        this.mobileMenuBtn = document.getElementById('nav-open-btn');
        this.menu = document.getElementById(this.mobileMenuBtn.dataset.target);
        this.bodyClassList = document.body.classList;
        this.header = document.getElementById('header-wrapper');
        this.secondNav = document.querySelector('.section-nav');
        this.globalNav = document.getElementById('global-nav');
        this.globalNavWrapper = document.querySelector('.global-nav-wrapper');
        this.globalNavContainer = document.querySelector('.global-nav-container');
        this.globalNavOverlay = document.getElementById('global-nav-overlay');
        this.globalNavDefault = document.querySelector('#sports-nav .menu-title');

        // the inner menu selectors strings
        let innerMenuStr = `
            #sports-nav > li,
            #watch-nav > li,
            #fantasy-nav > li,
            #more-nav > li,
            #account-nav > li.logged-in,
            #follow-nav > li,
            #shows-nav > li
        `;

        this.innerMenu = document.querySelectorAll(innerMenuStr);
        this.mActivator = document.querySelector('.m-nav-activator');
        this.topLevel = document.querySelector('.section-nav .top-level');
        this.navOverflow = document.querySelectorAll('.nav-overflow-more');
        this.throttle = ('ontouchstart' in document.documentElement) ? 50 : 10;
        this.lastScrollTop = 0;
        this.branchBannerHeight = 76;
        this.globalNavHeight = this.globalNavContainer.offsetHeight || 68;
        this.isGlobalNavHidden = false;
        this.bodyTagsAdded = false;
        this.sidebar = document.querySelector('#sidebar');
        this.sidebarClassList = (this.sidebar) ? this.sidebar.classList : null;
        this.screenLock = new screenLock();
        this.viewport = new Viewports({
            'mobile': 767,
            'desktop': 1024
        });

        this.setupScoreStrip();
        this.initEventListeners();

        // Adding a flag to the root element so we can hook into the template with CSS
        document.documentElement.className += " js-loaded";


    }

    setupScoreStrip() {
        this.scoreStrip = document.querySelector('#ScorestripContainer');
        if (this.scoreStrip) {
            this.scoreStripHeight = this.scoreStrip.offsetHeight || 75;
        }
        this.scorestripTagsAdded = false;
    }

    initEventListeners() {

        // Only bind the listener if the header exists.
        if (null !== this.header) {
            // bind "pin on scroll"
            this.watch = this.watch.bind(this);
            this.watch = scrollEvent.throttle(this.watch, this.throttle);
            window.addEventListener('scroll', this.watch.bind(this));

            // bind "define offset on resize"
            this.watchResize = this.watchResize.bind(this);
            this.watchResize = scrollEvent.throttle(this.watchResize, this.throttle);
            window.addEventListener('resize', this.watchResize.bind(this));


            // Only bind the listener if the mobile menu exists.
            if (null !== this.mobileMenuBtn) {
                this.mobileMenuBtn.addEventListener('click', () => this.menuToggler());
            }

            // Only bind the listener if an inner menu exists.
            if (this.innerMenu.length > 0) {
                Array.from(this.innerMenu).forEach(menu => {
                    //mouse event for hover on desktop
                    menu.addEventListener('mouseover', (e) => this.innerMenuToggler(menu, e));                    
                    //mouse event for click on desktop, mobile and ipad
                    menu.addEventListener('click', (e) => this.innerMenuToggler(menu, e));
                });
            }

            // Only bind the listener if an overflow menu links exists.
            if (this.navOverflow.length > 0) {
                Array.from(this.navOverflow).forEach(link => {
                    link.addEventListener('click', (e) => this.navOverflowToggler(e));
                });
            }
        }

    }
    /**
     * Handle toggling classes on the body, mobile menu button and mobile menu
     * for CSS styling and visibility when the menu is toggled on smaller screens.
     *
     * @since 0.1.0
     */
    menuToggler() {
        /**
         * If the mobile menu has the class 'active', remove it from the mobile menu,
         * the mobile menu toggle and remove the body tag class 'global-menu-open'.
         */
        if (this.bodyClassList.contains('global-menu-open') || this.bodyClassList.contains('section-nav-open')) {
            this.closeMenu();
            // Otherwise, set these elements to their active classes.
        } else {
            this.openMenu();
        }
    }
    closeMenu() {
        this.globalNavContainerTopPos = this.globalNavContainer.getBoundingClientRect().top || 0;
        if (this.viewport.getViewPort() === 'tablet' || this.bodyClassList.contains('branch-banner-is-active')) {
            this.globalNavWrapper.style.top = null;
        }
        this.mobileMenuBtn.classList.remove('active');
        this.menu.classList.remove('active');
        this.globalNavOverlay.classList.remove('show');
        this.globalNavWrapper.classList.remove('show');
        this.globalNavDefault.classList.remove('active');
        this.bodyClassList.remove('global-menu-open');
        this.screenLock.unlockScreen();

        return this;
    }
    openMenu() {
            if (this.bodyClassList.contains('branch-banner-is-active') && window.pageYOffset <= this.branchBannerHeight) {
                window.scrollTo(0, this.branchBannerHeight);
            }
            this.globalNavContainerTopPos = this.globalNavContainer.getBoundingClientRect().top || 0;
            this.mobileMenuBtn.classList.add('active');
            this.menu.classList.add('active');
            this.globalNavOverlay.classList.add('show');
            this.globalNavWrapper.classList.add('show');
            // When opening the menu, always reset to sports menu
            Array.from(this.innerMenu).forEach(item => {
                item.classList.remove('active');
            });
            this.globalNavDefault.classList.add('active');
            this.bodyClassList.add('global-menu-open');
            this.setGlobalNavWrapperHeight();
            this.screenLock.lockScreen();
            //close second nav if opened
            if (this.bodyClassList.contains('section-menu-open')) {
                this.mActivator.classList.remove('is-active');
                this.topLevel.classList.remove('is-active');
                this.bodyClassList.remove('section-menu-open');
            }
            if (this.bodyClassList.contains('scorestrip-open')) {
                if (window.scoreStrip) window.scoreStrip.minimize();
                this.bodyClassList.remove('scorestrip-open');
            }
            return this;
        }
        /**
         * Handle Adding/Removing 'active' from the inner menu item
         * effectively toggling a menu section's visibility.
         */
    innerMenuToggler(targetMenu, e) {
        /**
         * handle click event toggling on primary sub menus links on ipad
         * we need to add preventDefault on the links; otherwise, the drop down menu won't show on click/tap
         * instead it goes to href target url, and only apply preventDefault if there is subnav, meaning there is
         * <ul> tag next to <a> tag
         */
        if (e.type === "click" && this.checkIfTablet() && e.target.tagName.toLowerCase() === "a" && e.target.nextSibling) {
            e.preventDefault();
    
            let targetSubMenu = e.target.parentNode.querySelector('ul.sub-menu');
            Array.from(this.innerMenu).forEach(menu => {
                Array.from(menu.querySelectorAll('ul.sub-menu')).forEach(subMenu => {
                    if( subMenu != targetSubMenu ) subMenu.classList.remove('ipad-hidden','ipad-visible');
                });
            });
            this.toggleIpadMenuVisibility( targetSubMenu );
        }
        Array.from(this.innerMenu).forEach(menu => {
            if( menu != targetMenu ) menu.classList.remove('active');
        });
        targetMenu.classList.add('active');
    }
    /**
     * Handle visibility of overflow menu (specific for iPad landscape)
     */
    navOverflowToggler(e) {
        e.preventDefault();

        if( this.checkIfTablet() && e.target.nextSibling ) {
            let targetSubMenu = e.target;
            do {
                targetSubMenu = targetSubMenu.parentNode;
            }
            while(targetSubMenu.querySelector('ul.sub-menu') == null);
            targetSubMenu = targetSubMenu.querySelector('ul.sub-menu');
            Array.from(this.innerMenu).forEach(menu => {
                Array.from(menu.querySelectorAll('ul.sub-menu')).forEach(subMenu => {
                    if( subMenu != targetSubMenu ) subMenu.classList.remove('ipad-hidden','ipad-visible');
                });
            });
            this.toggleIpadMenuVisibility( targetSubMenu );
        }
    }
    /*
        toggle classname for hiding/showing nav menu
        NOTE: made for iPad/tablet viewport only
    */
    toggleIpadMenuVisibility( targetMenu ){

        if( targetMenu.classList.contains('ipad-visible') ){
            targetMenu.classList.remove('ipad-visible');
            targetMenu.classList.add('ipad-hidden');
        } else if ( targetMenu.classList.contains('ipad-hidden') ) {
            targetMenu.classList.remove('ipad-hidden');
            targetMenu.classList.add('ipad-visible');
        } else {
            targetMenu.classList.add('ipad-visible');
        }        
    }

    // stick - stick the navs
    stick() {
            this.globalStick();
            this.secondNavStick();
        }
        // unstick - unstick the navs
    unstick() {
        this.globalUnstick();
        this.secondNavUnstick();
    }
    addAppBannerBodyTags() {
            if (!this.bodyTagsAdded) {
                this.bodyClassList.remove('appBannerDisplayed');
                this.bodyClassList.add('appBannerHidden');
                this.bodyTagsAdded = true;
            }
        }
        // unstick for global nav
    removeAppBannerBodyTags() {
        if (this.bodyTagsAdded && !this.bodyClassList.contains('section-menu-open')) {
            this.bodyClassList.add('appBannerDisplayed');
            this.bodyClassList.remove('appBannerHidden');
            this.bodyTagsAdded = false;
        }
    }
    hideGlobalNav() {
        if (!this.isGlobalNavHidden) {
            //this.header.style.top = -this.globalNavHeight + 'px';
            this.header.classList.add('push-up');
            this.isGlobalNavHidden = true;
        }
    }
    showGlobalNav() {
        if (this.isGlobalNavHidden) {
            this.header.classList.remove('push-up');
            this.isGlobalNavHidden = false;
        }
    }
    setGlobalNavWrapperHeight() {
        this.globalNavWrapper.style.height = (window.innerHeight - 40) + 'px';

    }
    removeAllBodyClasses() {
        if (this.viewport.getViewPort() !== 'mobile') {
            if (window.pageYOffset <= this.getYOffset()) {
                if (this.sidebarClassList) this.sidebarClassList.remove('fix');
            }
            if (this.viewport.winW >= 1024 && this.bodyClassList.contains('scorestripHidden')) {
                this.hideGlobalNav()
            } else {
                this.showGlobalNav();
            }
        }
    }
    toggleSticky(stickPoint) {
        let scrollPos = window.pageYOffset || document.documentElement.scrollTop;
        let scorestripPresent = this.bodyClassList.contains('scorestrip-wide');
        if (this.bodyClassList.contains('branch-banner-is-active')) {
            if (scrollPos > stickPoint) {
                this.addAppBannerBodyTags();
            } else {
                this.removeAppBannerBodyTags();
            }
        }
    }

    // getYOffset = get Y offset
    getYOffset() {
        if (this.bodyClassList.contains('branch-banner-is-active')) {
            return this.branchBannerHeight;
        } else {
            return 0;
        }
    }

    checkIfTablet() {
        return (this.viewport.isTouch && 'desktop' === this.viewport.getViewPort());
    }

    /**
     * Watch for scrolling changes in direction.
     *
     * @since 0.1.0
     */
    watch() {

            if (this.bodyClassList.contains('global-menu-open') || document.body.classList.contains('scorestrip-open')) return;
            let pinPos = this.getYOffset();

            let st = window.pageYOffset || document.documentElement.scrollTop;
            // Desktop
            if (this.viewport.getViewPort() == 'desktop') {
                // Downscroll
                if (st > this.lastScrollTop) {
                    if (st > pinPos) {
                        this.addAppBannerBodyTags();
                    }
                    // Upscroll
                } else {
                    if (st < (this.lastScrollTop - 1)) {
                        if (st < pinPos) {
                            this.removeAppBannerBodyTags();

                        }
                    }
                }
            } else {
                // Mobile/Tablet
                this.toggleSticky(this.getYOffset());
            }
            // Update the lastScrollTop value to the page's offset.
            this.lastScrollTop = st;
        }
        /**
         * Watch for resize and orientation change.
         */
    watchResize() {
        this.viewport.setWinW(window.innerWidth);
        this.globalNavHeight = this.globalNavContainer.offsetHeight;
        if (this.globalNavWrapper.classList.contains('show') && this.viewport.winW >= 1024) {
            this.closeMenu();
        } else if (this.globalNavWrapper.classList.contains('show')) {
            this.setGlobalNavWrapperHeight();
        }
        //removes body tags when resizing
        this.removeAllBodyClasses();
    }
}

export default NavGlobal;


// WEBPACK FOOTER //
// ./assets/components/navGlobal/navGlobal.js